import { Deserializable } from '../../deserializable';
import { ArtefactDetailsDto } from './artefact-details-dto.model';

export class ApplicationCaseDetailsDto implements Deserializable {
  public AdvisedArtefact: ArtefactDetailsDto;
  public Artefacts: Array<ArtefactDetailsDto>;
  public AdvisedArtefacts: Array<ArtefactDetailsDto>;
  public IsCaseEditableByExternalUsersBasedOnTheCaseDecision: boolean;
  public CaseType: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.AdvisedArtefact = new ArtefactDetailsDto().deserialize(input.AdvisedArtefact);

    this.Artefacts =
      input !== undefined && input.Artefacts !== undefined
        ? input.Artefacts.map((artefactDetailsDto: ArtefactDetailsDto) =>
            new ArtefactDetailsDto().deserialize(artefactDetailsDto)
          )
        : undefined;

    this.AdvisedArtefacts =
      input !== undefined && input.AdvisedArtefacts
        ? input.AdvisedArtefacts.map((artefactDetailsDto: ArtefactDetailsDto) =>
            new ArtefactDetailsDto().deserialize(artefactDetailsDto)
          )
        : undefined;

    return this;
  }
}
